<template>
    <div class="container">
        <ul>
            <StoryItem v-for="story in stories" :key="story.id" :story="story" />
        </ul>
    </div>
</template>

<script setup lang="ts">
import StoryItem from "@/components/TeamStory/StoryItem.vue";
import { TeamStory } from "@/services/entities/teamStory";

const { stories } = defineProps<{
    stories: TeamStory[];
}>();
</script>

<style lang="scss" scoped>
ul {
    list-style-type: none;
    padding: 0;
}

.container {
    width: 100%;
}
</style>
